<template>
    <b-container class="container-panel">
        <b-card no-body>
            <b-tabs content-class="mt-3" v-model="tabIndex">
                <b-tab title="Invoice(s)">
                    <b-card-header><h3>Deferred Payment Plan - Invoice(s)</h3></b-card-header>
                    <b-card-header>Payment Plan Amount: ${{PaymentPlanTotal.toFixed(2)}}</b-card-header>
                    <b-card-body>
                        <b-table :items="EligibleInvoices" :fields="EligibleInvoicesFields" striped outlined>
                            <template #cell(invoiceDate)="row">
                                {{ new Date(row.item.invoiceDate).toLocaleDateString() }}
                            </template>
                            <template #cell(invoiceChargesDisplay)="row">
                                ${{ Number.parseFloat(row.item.invoiceChargesDisplay).toFixed(2) }}
                            </template>
                            <template #cell(paymentDisplay)="row">
                                ${{ Number.parseFloat(row.item.paymentDisplay).toFixed(2) }}
                            </template>
                            <template #cell(amountDisplay)="row">
                                ${{ Number.parseFloat(row.item.amountDisplay).toFixed(2) }}
                            </template>
                        </b-table>
                    </b-card-body>
                </b-tab>
                <b-tab title="Payment Schedule">
                    <b-card-header><h3>Deferred Payment Plan - Payment Schedule</h3></b-card-header>
                    <b-card-header>Payment Plan Amount: ${{PaymentPlanTotal.toFixed(2)}}</b-card-header>
                    <b-card-header>Recent Payment Amount: ${{RecentPaymentAmount.toFixed(2)}}</b-card-header>
                    <b-card-header>Required Deposit Amount: ${{depositInfo.depositAmount.toFixed(2)}}</b-card-header>
                    <b-card-body>
                        <b-row>
                            <b-col lg="4" class="mx-auto py-3">
                                <b-button :disabled="PaymentCount == maxPaymentCount" size="sm" @click="addInstallment">Add Installment</b-button>
                            </b-col>
                            <b-col lg="4" class="mx-auto py-3">
                                <b-button :disabled="PaymentCount == 2" size="sm" @click="deleteInstallment">Delete Installment</b-button>
                            </b-col>
                        </b-row>
                        <b-table :items="PaymentSchedule" :fields="PaymentScheduleFields" striped outlined>
                            <template #cell(amount)="data">
                                <input v-model="data.item.amount" :class="{'input--error':!data.item.validInput}"
                                       :disabled="data.item.disabled"
                                        v-on:keyup.enter="calculatePaymentScheduleTotalEvent($event)"
                                        v-on:blur="calculatePaymentScheduleTotalEvent($event)" />
                            </template>
                        </b-table>
                    </b-card-body>
                </b-tab>
                <b-tab title="Agreement">
                    <b-card-header><h3>Deferred Payment Plan - Agreement</h3></b-card-header>
                    <b-card-body>
                        <p v-show="showSwitchHoldVerbiage">{{$t('DPP_AGREEMENT1')}} </p>
                        <p v-show="showSwitchHoldVerbiage">{{$t('DPP_AGREEMENT2')}} </p>
                        <p>{{$t('DPP_AGREEMENT3')}} </p>
                        <input type="checkbox" id="checkbox" v-bind:value="true" v-model="customerAgreement" />
                        <span>{{$t('DPP_AGREEMENT4')}}</span>
                        <b-list-group>
                            <textarea :class="{'input--error':this.EnrollMessage.length > this.EnrollMessageLimit}" v-model="EnrollMessage" placeholder="add enrollment notes"></textarea>
                            <b-list-group-item>{{ charactersLeft }}</b-list-group-item>
                        </b-list-group>
                    </b-card-body>
                </b-tab>
            </b-tabs>
            <b-row>
                <b-col lg="2" class="mx-auto py-3">
                    <b-button :disabled="tabIndex == 0" @click="tabIndex--">Previous</b-button>
                </b-col>
                <b-col lg="2" class="mx-auto py-3">
                    <b-button :disabled="tabIndex == 2" @click="tabIndex++">Next</b-button>
                </b-col>
                <b-col lg="2" class="mx-auto py-3">
                    <b-button class="btn btn-primary" variant="primary" @click="validate" :disabled='!customerAgreement'>Enroll</b-button>
                </b-col>
            </b-row>
        </b-card>
    </b-container>
</template>

<script>
    import AmbitLogo from '../components/AmbitLogo.vue';
    import Email from '../components/Email.vue';
    import LanguageSelection from '../components/LanguageSelection.vue';
    import Repo from '../repo';
    import { mapGetters } from 'vuex';


    export default {
        name: "PaymentPlanEnroll",
        props: {
            permissions: Array,
            depositInfo: Object
        },
        components: { AmbitLogo, Email, LanguageSelection },
        data() {
            return {
                showForm: false,
                showEmail: false,
                PaymentCount: 6,
                EligibleInvoices: [],
                PaymentScheduleTotal: 0,
                RecentPaymentAmount: 0,
                PaymentPlanOffers: {},
                PaymentPlanTotal: 0,
                WillTriggerSwitchHold: false,
                customerAgreement: false,
                maxPaymentCount: 6,
                tabIndex: 0,
                EnrollMessage: '',
                EnrollMessageLimit: 100,
                createPaymentPlanRequest: {
                    installments: [],
                    amount: 0,
                    invoices: [],
                    notes: '',
                    name: "Deferred Payment Plan",
                },
                EligibleInvoicesFields: [
                    { key: 'externalBillNbr', label: 'Invoice #' },
                    { key: 'invoiceDate', label: 'Invoice Date' },
                    { key: 'invoiceChargesDisplay', label: 'Invoice Amount' },
                    { key: 'paymentDisplay', label: 'Payment' },
                    { key: 'amountDisplay', label: 'Balance' },
                ],
                PaymentScheduleFields: [
                    { key: 'installmentDate', label: 'Installment Date' },
                    { key: 'amount', label: 'Amount Due' },
                    { key: 'deposit', label: 'Deposit Due Now'},
                    { key: 'totalDueNow', label: 'Total Due Now' },
                ]
            }
        },
        mounted: async function () {
            await this.getCustomerPaymentPlanEligibleInvoices(this.$route.params.customerNumber);
            await this.getDeferredPaymentPlanInformation(this.$route.params.customerNumber, true, 0);
            //await this.getDepositSummary(this.$route.params.customerNumber);
            this.$store.dispatch('shell/updateLanguageFromQuery', this.$route.query.lang);
            this.checkMaxPaymentCount();
        },
        methods: {
            changePage(page) {
                this.showForm = page === "form";
                this.showEmail = page === "email";
            },
            addInstallment() {
                this.PaymentCount += 1;
            },
            deleteInstallment() {
                if (this.PaymentCount > 2) {
                    this.PaymentCount -= 1;
                }
            },
            async calculatePaymentScheduleTotalEvent($event) {
                await this.getDeferredPaymentPlanInformation(this.$route.params.customerNumber, false, this.PaymentSchedule[0].amount);
            },
            getCustomerPaymentPlanEligibleInvoices(customerNbr) {
                return new Promise((resolve, reject) => {
                    this.$store.dispatch('shell/turnOnSpinner', true);
                    Repo.PaymentPlanService.GetCustomerPaymentPlanEligibleInvoices({ customerNumber: customerNbr }).then(res => {
                        if (res.eligibleInvoices != null && res.eligibleInvoices.length > 0) {
                            res.eligibleInvoices.forEach(e => {
                                e.amount = e.pastDueAmt;
                                e.payment = (Math.round((e.invoiceCharges - e.pastDueAmt) * 100) / 100);
                                e.paymentDisplay = e.payment ? e.payment.toFixed(2) : 0.00;
                                e.invoiceChargesDisplay = e.invoiceCharges ? e.invoiceCharges.toFixed(2) : 0.00;
                                e.amountDisplay = e.pastDueAmt.toFixed(2);
                                e.includeInPayPlan = true;
                                e.amountSelected = true;
                            });
                            this.EligibleInvoices = res.eligibleInvoices;
                        }
                        this.$store.dispatch('shell/turnOffSpinner', false);
                        resolve(true);
                    });
                });
            },
            getDeferredPaymentPlanInformation(customerNbr, isDefaultFirstInstallmentAmount, firstInstallmentAmount) {
                return new Promise((resolve, reject) => {
                    this.$store.dispatch('shell/turnOnSpinner', true);
                    Repo.PaymentPlanService.GetDeferredPaymentPlanInformation({
                        customerNbr: customerNbr
                        , IsDefaultFirstInstallmentAmount: isDefaultFirstInstallmentAmount
                        , FirstInstallmentAmount: firstInstallmentAmount
                    }).then(res => {
                        if (res.canEnroll != null && res.canEnroll == true && res.paymentPlanOffers.length > 0) {
                            this.PaymentPlanOffers = res.paymentPlanOffers;   
                            this.RecentPaymentAmount = res.recentPaymentAmount;
                            this.PaymentPlanTotal = res.paymentPlanAmount;
                            this.WillTriggerSwitchHold = res.willTriggerSwitchHold;
                        }
                        this.$store.dispatch('shell/turnOffSpinner', false);
                        resolve(true);
                    });
                });
            },
            validate() {
                if (this.EnrollMessage.length <= this.EnrollMessageLimit) {
                    this.createPaymentPlanRequest.installments = this.PaymentSchedule;
                    this.createPaymentPlanRequest.amount = this.PaymentPlanTotal;
                    this.createPaymentPlanRequest.notes = this.EnrollMessage;
                    this.createPaymentPlanRequest.invoices = this.EligibleInvoices.filter(function (x) {
                        return x.includeInPayPlan
                    });
                    this.$emit('pay', this.createPaymentPlanRequest);
                }
                return;
            },
            onClickButton() {

            },
            checkMaxPaymentCount() {
                if (this.permissions.includes(105101)) {
                    this.maxPaymentCount = 6;
                } else if (this.permissions.includes(105102)) {
                    this.maxPaymentCount = 12;
                } else if (this.permissions.includes(105103)) {
                    this.maxPaymentCount = 12;
                }
                console.log(this.maxPaymentCount);
                return;
            }
        },
        computed: {
            PaymentSchedule: function () {
                var schedule = [];
                if (this.PaymentPlanOffers.length > 0) {
                    console.log('here1')
                    console.log(this.PaymentPlanOffers)
                    console.log(this.PaymentPlanOffers[this.PaymentCount - 2])
                    console.log(this.PaymentPlanOffers.length)
                    console.log(schedule)
                    console.log(schedule.length)
                    this.PaymentPlanOffers[this.PaymentCount - 2].paymentInstallments.forEach(x => {
                        if (schedule.length == 0) {
                            var firstInstallmentAmount = x - this.depositInfo.depositAmount;
                            console.log("Amount")
                            console.log(firstInstallmentAmount)
                            schedule.push({ installmentDate: 'Due Now', amount: firstInstallmentAmount.toFixed(2), deposit: '$' + this.depositInfo.depositAmount.toFixed(2), totalDueNow: '$' + x.toFixed(2), totalDueNowAmount: x.toFixed(2), disabled: false })
                        } else {
                            schedule.push({ installmentDate: '', amount: x.toFixed(2), totalDueNow: '', disabled: true })
                        }
                    })
                }
                console.log('here2')
                return schedule;
            },
            showSwitchHoldVerbiage() {
                if (this.WillTriggerSwitchHold != null) {
                    return this.WillTriggerSwitchHold
                } else {
                    return true;
                }
            },
            charactersLeft() {
                var char = this.EnrollMessage.length;
                var limit = this.EnrollMessageLimit;

                return (limit - char) + " / " + limit + " characters remaining";
            },
        },
        watch: {
            permissions: function (newVal, oldVal) {
                this.checkMaxPaymentCount();
            }
        }
    }
</script>